import { render, staticRenderFns } from "./BatchConfirmAlert.vue?vue&type=template&id=5981afea"
import script from "./BatchConfirmAlert.vue?vue&type=script&lang=js"
export * from "./BatchConfirmAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports